__turbopack_context__.v({
  "buttonCaption": "HeaderNavigation-module-scss-module__wJBajq__buttonCaption",
  "condensed": "HeaderNavigation-module-scss-module__wJBajq__condensed",
  "highlightNavigation": "HeaderNavigation-module-scss-module__wJBajq__highlightNavigation",
  "logo": "HeaderNavigation-module-scss-module__wJBajq__logo",
  "menuOpen": "HeaderNavigation-module-scss-module__wJBajq__menuOpen",
  "navigationButton": "HeaderNavigation-module-scss-module__wJBajq__navigationButton",
  "navigationButtons": "HeaderNavigation-module-scss-module__wJBajq__navigationButtons",
  "navigationContainer": "HeaderNavigation-module-scss-module__wJBajq__navigationContainer",
  "navigationIcon": "HeaderNavigation-module-scss-module__wJBajq__navigationIcon",
  "search": "HeaderNavigation-module-scss-module__wJBajq__search",
  "title": "HeaderNavigation-module-scss-module__wJBajq__title",
});
